import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isFunction, isString, isArray } from 'intact-shared';
export function useColor() {
  var instance = useInstance();
  var backGroundColor = useState(undefined);
  function setColor() {
    var _instance$get = instance.get(),
      percent = _instance$get.percent,
      color = _instance$get.color;
    if (!color) return;
    if (isFunction(color)) {
      backGroundColor.set(color(percent));
    } else if (isArray(color)) {
      var item = _findInstanceProperty(color).call(color, function (v) {
        return v.percent === percent;
      });
      if (item && item.color) {
        backGroundColor.set(item.color);
      }
    } else if (isString(color)) {
      backGroundColor.set(color);
    }
  }
  instance.on('$receive:color', setColor);
  instance.watch('percent', setColor);
  return backGroundColor;
}